// 存储localStorage
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};
// 获取localStorage
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
// 统一删除缓存
export const remove = () => {
  removeStore("codes");
  removeStore("user");
  removeStore("Address");
  removeStore("statusCode");
  // removeStore("shareHttp");  //分享进来存的链接参数 地址
  // removeStore("recomCustomerId");   //分享人ID
  
  
  
  
};
